module.exports = __webpack_public_path__ + "img/gartek-portfolio-edicational.704a7e72.jpeg";